export { default as theme } from 'prism-themes/themes/prism-darcula.css';
